import type { CellContext } from "@msuite/ui/table";
import type { AutoIntegrationListItem, PersonioPerson, WebfleetObject } from "@msuite/utils/types";

export function RowActions(
	_props: CellContext<AutoIntegrationListItem<WebfleetObject | PersonioPerson>, "actions">,
) {
	return <div />;
}
